import { ArrowRightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import useAnalyticsEventTracker from '../hooks/useAnalyticsEventTracker';

const MenuCard = (props) => {
    const { id, name, image, description, view_only, ...rest } = props;
    const navigate = useNavigate();
    const logGAEvent = useAnalyticsEventTracker('MenuCard');
    const IMAGE_ROOT_URL = process.env.REACT_APP_AWS_ASSETS_ROOT_URL;

    const menuCLickHandler = (id, view_only) => {
        logGAEvent('menu_card_click', id);
        localStorage.setItem('menuID', JSON.stringify(id));
        localStorage.setItem('isViewOnly', Boolean(view_only));
        navigate(`/ordermenu?menuid=${id}`);
    };
    return (
        <div
            className='mb-6 bg-white rounded-3xl shadow-lg'
            onClick={() => menuCLickHandler(id, view_only)}
        >
            {image && (
                <img
                    className='rounded-t-3xl h-72 w-full object-cover'
                    src={`${IMAGE_ROOT_URL}menus/${image}`}
                    alt='menu-img'
                />
            )}
            <div className='p-5 flex flex-row justify-between'>
                <div className='text-sm font-medium'>{name}</div>
                <ArrowRightOutlined />
            </div>
        </div>
    );
};

export default MenuCard;
